import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';

export const FooterContainer = styled.footer`
  background: #050505;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 56px 0 28px;
  position: relative;
  z-index: 10;
`;

export const Inner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 36px;
  flex-wrap: wrap;
  padding-bottom: 36px;
`;

export const Brand = styled.div`
  max-width: 360px;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    font-family: 'Ubuntu', sans-serif;
    display: flex;
    align-items: center;
  }
  span.dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: ${(props) => props.theme.text};
    margin-left: 4px;
    align-self: flex-end;
    margin-bottom: 6px;
  }
  p {
    margin-top: 12px;
    font-size: 14.5px;
    line-height: 1.7;
    color: #8b94a3;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 28px;
`;

export const FLink = styled(LinkS)`
  font-size: 14.5px;
  color: #aab2c0;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
  }
`;

export const Socials = styled.div`
  display: flex;
  gap: 12px;
`;

export const SocialIconLink = styled.a`
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #c4ccd8;
  font-size: 19px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
    border-color: ${(props) => props.theme.text};
    transform: translateY(-3px);
  }
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
`;

export const Rights = styled.small`
  color: #6b7280;
  font-size: 13px;
`;

export const ToTop = styled(LinkS)`
  font-size: 13px;
  font-weight: 600;
  color: #aab2c0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
  }
`;
